import config from "../../config";
import { GET_FAVORITES } from "./types";

export const GetFavoritesAction = () => async (dispatch, getState) => {
    try {
        const token = getState().auth.token;
        const url = config.services.favorite();
        const headers = config.bearerHeaders(token);
        const res = await config.getApi(url, headers);
        if (res) {
            dispatch({
                type: GET_FAVORITES,
                payload: res.response.data.favorites,
            });
        }
    } catch (e) {
        console.warn(e);
    }
};
